<template>
  <div class="tip-wrap bg-white p15">
    <span v-if="hidePrompt" style="color: #c1121e">温馨提示：</span>{{ tips }}
  </div>
</template>
<script>
export default {
  props: {
    hidePrompt: {
      type: Boolean,
      default: true,
    },
    tips: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.tip-wrap {
  font-size: 13px;
  font-weight: 400;
  color: #333;
  line-height: 18px;
}
.tips-wrap {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}
</style>